<template lang="pug">
el-tooltip(
    v-if='tipo==="label-circulo"'
    effect='light',
    placement='top',
    :content='texto'
)
    div(:class='[tipo, "label"]' :style='estilo')

div(v-else-if='tipo==="label-barra"' :class='[tipo, "label"]' :style='estilo') {{ texto }}

div(v-else :style='estilo') {{ texto }}
</template>

<script>
import LabelTipo from '@/constants/LabelTipo';

export default {
    name: 'Label',

    props: {
        tipo: {
            type: String,
            required: true
        },
        estilo: {
            require: true
        },
        texto: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            tipoBarra: LabelTipo.BARRA,
            tipoCirculo: LabelTipo.CIRCULO
        };
    }
};
</script>

<style lang="scss" scoped>
.label {
    border-width: 1px;
    border-style: solid;
}

.label-barra {
    border-radius: 4px;
    text-align: center;
    padding: 2px 10px 2px 10px;
    max-width: 150px;
}

.label-circulo {
    height: 27px;
    width: 27px;
    border-radius: 50%;
    display: inline-block;
    margin: 0 auto;
}
</style>
